$(function ($) {
  /*---------------- Shop Slider ------------------*/
  /*start: product details thumb slider*/
  $('.shop-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: false,  
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,          
          vertical: false,
          arrows: true
        }
      }, 
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,          
          vertical: false,
          arrows: true
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          arrows: true
        }
      },
      {
        breakpoint: 381,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false,
          arrows: true
        }
      }
    ]
  });

  $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  $('.shop-slider-nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(".shop-slider-nav .slick-slide").each(function () {
      $(this).find('.thumb-container').removeClass('custom-border');
    });
    $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  });
  /*end: product details thumb slider*/

  /*---------------- best-sellers ------------------*/
  $('.best-sellers-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    responsive: [{
      breakpoint: 1301,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
                 {
                   breakpoint: 1200,
                   settings: {
                     slidesToShow: 4,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 992,
                   settings: {
                     slidesToShow: 3,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 768,
                   settings: {
                     rows: 2,
                     slidesToShow: 2,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 481,
                   settings: {
                     rows: 2,
                     slidesToShow: 1,
                     slidesToScroll: 1
                   }
                 }

                ]
  });


});

/*---------------- Stories Tab section ------------------*/

$(document).ready(function() {
  if ($('#parentHorizontalTab').length) {
    $('#parentHorizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });
  }
});
/*---------- properties main slider -----------*/

/*---------------- main Banner ------------------*/
$('.main-banner').slick({
  dots: true,
  arrows: false,
  adaptiveHeight: true

});

/* PLP PRODUCTS 	EQUAL HEIGHT Starts  */
$(window).load(function() {
  equalheight('.best-sellers-product-box .prodimg a');
  equalheight('.prod-content .prod-title');
  equalheight(".best-sellers-product-box a");
  equalheight(".best-sellers-section .best-sellers-product-box .prodimg a");
  equalheight(".shop-item-list .img");
  equalheight(".best-sellers-product-box .img");
  equalheight(".best-sellers-colum");
  equalheight(".best-title a");
  // equalheight(".best-sellers-product-box .text");
  equalheight(".collectionwrap .shop-item-colum");
  equalheight(".shop-item-list .text p");

});


$(window).resize(function() {
  equalheight('.best-sellers-product-box .prodimg a');
  equalheight('.prod-content .prod-title');
  equalheight(".best-sellers-product-box a");
  equalheight(".best-sellers-section .best-sellers-product-box .prodimg a");
  equalheight(".shop-item-list .img");
  equalheight(".best-sellers-colum");
  equalheight(".best-title a");
  // equalheight(".best-sellers-product-box .text");
  equalheight(".collectionwrap .shop-item-colum");
  equalheight(".shop-item-list .text p");  
}); 


/*---------------- Shop page Fileter Mobile ------------------*/

$(".filter-btn").click(function() {
  $(".sidebar-col").addClass("sidebar-open");
});
$(".close-btn").click(function() {
  $(".sidebar-col").removeClass("sidebar-open");
});

/*---------------- Sidebar ------------------*/

$('.sidebar-content > .panel-title').on("click", function(e) {
  $(this).next('.panel-body').slideToggle(600);
  $(this).toggleClass('open');
  e.stopPropagation();
  e.preventDefault();
});

$('.sidebar-content').on("click", '.hasdropdown > label > a', function(e) {
  e.stopPropagation();
  e.preventDefault();
  $(this).closest('.hasdropdown').find('ul.hasdropdownmenu').slideToggle(600);
  $(this).toggleClass('open');
});



var toadd = [];
function moveAlong () {
  // If we still have requests in the queue, let's process the next one.
  if (toadd.length) {
    var request = toadd.shift();
    var data = 'id='+ request.variantId + '&quantity='+request.quantity
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(res){
        moveAlong();
      },
      error: function(){
        // if it's not last one Move Along else update the cart number with the current quantity
        if (toadd.length){
          moveAlong()
        } else {	

        }
      }
    });
  }
  // If the queue is empty, we add 1 to cart
  else {	 
    location.href='/cart';
  }
}

$('.addallvariants').click(function(){
  $('.addvariantwrap').each(function () {
    var quantity= parseInt($(this).val());
    var variantId = $(this).attr("data-variant");
    toadd.push({
      variantId:variantId,
      quantity:quantity,
    });
  });
  //     console.log(toadd);
  moveAlong();
});



$('.productView-thumbnail.slick-slide [data-variant="black"]').click();

$('body').on('click','.var-img-chg',function(e) {
  var get_cur_img = $(this).data('var-imgid');
  
  if (get_cur_img != '') {
     $(".product-single__photo").each(function () {
      $(this).addClass('hide');
      var get_ele = $(this);
      var current_slide_img = $(this).data('image-id');
      if (get_cur_img == current_slide_img) {
        $(get_ele).removeClass('hide');
      }
    });
    $(".shop-slider-nav .slick-slide").each(function () {
      var current_slide_img = $(this).find('img').data('var-imgid');
      if (get_cur_img == current_slide_img) {
        var get_current_slide_no = $(this).data('slick-index');
        $('.shop-slider-nav').slick('slickGoTo', get_current_slide_no);
      }
    });
  }
});